/* @flow */
import ExtendableError from 'es6-error';

export class AbortError extends ExtendableError {
    name: string;

    constructor(message: string, name: string) {
        super(message);
        this.name = name;
    }
}
export class ApiError extends ExtendableError {
    statusCode: ?number;

    constructor(message: string, statusCode?: number) {
        super(message);
        this.statusCode = statusCode;
    }
}

export class ErrorWithAutoAcknowldge extends ApiError {
    autoAcknowledgeTimeout: number;
    constructor(message: string, autoAcknowledgeTimeout: number) {
        super(message);
        this.autoAcknowledgeTimeout = autoAcknowledgeTimeout;
    }
}
